export enum NaaProfileTypeEnum {
  Supplier = 1,
  Owner = 2,
  ManagementCompany = 3,
  Property = 4,
  Affiliate = 5,
  GeneralOrganization = 6,
  Individual = 7,
}
